module.exports = __webpack_public_path__ + "media/icons/tapicerka-skorzana-unactive-c5904a00.png";